import { useLocation, useNavigate } from 'react-router-dom';
import { useSwitchToFacility } from '../../../components/layouts/useSwitchToFacility';

/** Page du back-office à rouvrir depuis le bandeau « Revenir ». */
export const LIBRARY_RETURN_PATH_KEY = 'TEMPLATE_LIBRARY_RETURN_PATH';

/**
 * Ouvre un modèle dans son éditeur réel, sur l'hôtel qui le porte : on bascule
 * d'abord l'établissement consulté (sans usurpation), puis on navigue, sinon
 * l'éditeur listerait et créerait ses e-mails et formulaires chez l'hôtel
 * sélectionné. La bascule remonte la page : on navigue juste après.
 */
export function useOpenInLibrary() {
    const { switchTo, pendingId } = useSwitchToFacility();
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const open = async (facilityId: number, editorPath: string) => {
        try {
            sessionStorage.setItem(LIBRARY_RETURN_PATH_KEY, pathname);
        } catch {
            // Stockage indisponible (navigation privée) : le retour ira au tableau de bord.
        }
        if (await switchTo(facilityId)) {
            navigate(editorPath);
        }
    };

    return { open, pendingId };
}
